<template>
  <div class="driver-analysis-page">
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title"><i class="el-icon-user"></i> 司机分析</h2>
        <span class="page-desc">分析司机出勤趋势、状态分布及经营排行</span>
      </div>
    </div>
    <!-- 顶部筛选栏 -->
    <div class="filter-bar">
      <div class="filter-left">
        <el-radio-group v-model="timeType" size="small" @change="loadData">
          <el-radio-button :label="0">今日</el-radio-button>
          <el-radio-button :label="1">昨日</el-radio-button>
          <el-radio-button :label="2">近7天</el-radio-button>
          <el-radio-button :label="3">近30天</el-radio-button>
          <el-radio-button :label="4">近半年</el-radio-button>
          <el-radio-button :label="5">近一年</el-radio-button>
        </el-radio-group>
      </div>
      <div class="filter-right">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="loadData" :loading="loading">刷新数据</el-button>
      </div>
    </div>

    <!-- 概览卡片 6个 -->
    <div class="section-title"><i class="el-icon-user"></i> 司机概览</div>
    <div class="overview-cards">
      <div class="ov-card">
        <div class="ov-card-icon" style="background:linear-gradient(135deg,#409EFF,#66B1FF)"><i class="el-icon-user"></i></div>
        <div class="ov-card-info"><div class="ov-card-value">{{ stats.totalDrivers }}</div><div class="ov-card-label">司机总数</div></div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background:linear-gradient(135deg,#67C23A,#85CE61)"><i class="el-icon-location"></i></div>
        <div class="ov-card-info"><div class="ov-card-value">{{ stats.onlineDrivers }}</div><div class="ov-card-label">在线司机</div></div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background:linear-gradient(135deg,#E6A23C,#EBB563)"><i class="el-icon-s-promotion"></i></div>
        <div class="ov-card-info"><div class="ov-card-value">{{ stats.runningDrivers }}</div><div class="ov-card-label">运营中</div></div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background:linear-gradient(135deg,#9B59B6,#B07CC6)"><i class="el-icon-s-order"></i></div>
        <div class="ov-card-info"><div class="ov-card-value">{{ stats.periodOrders }}</div><div class="ov-card-label">期间总工单</div></div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background:linear-gradient(135deg,#F56C6C,#F78989)"><i class="el-icon-money"></i></div>
        <div class="ov-card-info"><div class="ov-card-value">¥{{ formatMoney(stats.periodRevenue) }}</div><div class="ov-card-label">期间总收入</div></div>
      </div>
      <div class="ov-card">
        <div class="ov-card-icon" style="background:linear-gradient(135deg,#1abc9c,#2ecc71)"><i class="el-icon-circle-check"></i></div>
        <div class="ov-card-info"><div class="ov-card-value">{{ stats.avgCompletionRate }}%</div><div class="ov-card-label">平均完成率</div></div>
      </div>
    </div>

    <!-- 图表 3列 -->
    <div class="charts-grid">
      <div class="chart-card" style="grid-column:span 2">
        <div class="chart-card-header">
          <span><i class="el-icon-data-line"></i> 司机出勤趋势</span>
          <el-radio-group v-model="attendanceTimeType" size="mini" @change="loadAttendanceTrend">
            <el-radio-button :label="0">今日</el-radio-button>
            <el-radio-button :label="7">近7天</el-radio-button>
            <el-radio-button :label="30">近30天</el-radio-button>
            <el-radio-button :label="180">近半年</el-radio-button>
            <el-radio-button :label="365">近一年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-body" ref="attendanceTrendChart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-card-header"><span><i class="el-icon-pie-chart"></i> 司机状态分布</span></div>
        <div class="chart-body" ref="driverStatusChart"></div>
      </div>
    </div>

    <!-- 图表 2列：排行柱状图 + 收入分布 -->
    <div class="charts-grid-half">
      <div class="chart-card">
        <div class="chart-card-header">
          <span><i class="el-icon-s-data"></i> 司机订单排行 TOP10</span>
          <el-radio-group v-model="rankTimeType" size="mini" @change="loadDriverRankChart">
            <el-radio-button :label="0">今日</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">近30天</el-radio-button>
            <el-radio-button :label="4">近半年</el-radio-button>
            <el-radio-button :label="5">近一年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-body" ref="driverRankChart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-card-header">
          <span><i class="el-icon-coin"></i> 司机收入排行 TOP10</span>
          <el-radio-group v-model="incomeRankTimeType" size="mini" @change="loadDriverIncomeChart">
            <el-radio-button :label="0">今日</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">近30天</el-radio-button>
            <el-radio-button :label="4">近半年</el-radio-button>
            <el-radio-button :label="5">近一年</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-body" ref="driverIncomeChart"></div>
      </div>
    </div>

    <!-- 完整排行明细表 -->
    <div class="table-card" style="margin-bottom:20px">
      <div class="chart-card-header">
        <span><i class="el-icon-medal"></i> 司机经营排行明细</span>
        <el-radio-group v-model="tableTimeType" size="mini" @change="loadDriverTable">
          <el-radio-button :label="0">今日</el-radio-button>
          <el-radio-button :label="2">近7天</el-radio-button>
          <el-radio-button :label="3">近30天</el-radio-button>
          <el-radio-button :label="4">近半年</el-radio-button>
          <el-radio-button :label="5">近一年</el-radio-button>
        </el-radio-group>
      </div>
      <el-table :data="driverTableData" border stripe size="small" max-height="400" style="width:100%" v-loading="tableLoading">
        <el-table-column type="index" label="序" width="45" />
        <el-table-column prop="driverName" label="司机姓名" min-width="90" />
        <el-table-column prop="driverPhone" label="电话" min-width="110" />
        <el-table-column prop="orderCount" label="工单数" min-width="70" sortable />
        <el-table-column prop="finishCount" label="完成" min-width="60" sortable />
        <el-table-column prop="passengerCount" label="乘客" min-width="60" sortable />
        <el-table-column label="总收入" min-width="100" sortable prop="totalRevenue">
          <template slot-scope="{row}"><span style="color:#67C23A;font-weight:600">¥{{ row.totalRevenue || '0.00' }}</span></template>
        </el-table-column>
        <el-table-column label="司机分成" min-width="100" prop="driverIncome">
          <template slot-scope="{row}"><span style="color:#409EFF">¥{{ row.driverIncome || '0.00' }}</span></template>
        </el-table-column>
        <el-table-column label="客单价" min-width="80" prop="avgOrderFee">
          <template slot-scope="{row}">¥{{ row.avgOrderFee || '0.00' }}</template>
        </el-table-column>
        <el-table-column label="完成率" min-width="110" prop="completionRate">
          <template slot-scope="{row}">
            <el-progress v-if="row.completionRate != null" :percentage="Number(row.completionRate) || 0"
              :stroke-width="14" :text-inside="true"
              :color="row.completionRate >= 80 ? '#67C23A' : row.completionRate >= 50 ? '#E6A23C' : '#F56C6C'" />
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "DriverAnalysis",
  data() {
    return {
      loading: false,
      tableLoading: false,
      timeType: 0,
      stats: {
        totalDrivers: 0,
        onlineDrivers: 0,
        runningDrivers: 0,
        periodOrders: 0,
        periodRevenue: 0,
        avgCompletionRate: 0
      },
      attendanceTimeType: 0,
      rankTimeType: 3,
      incomeRankTimeType: 3,
      tableTimeType: 3,
      driverTableData: [],
      charts: {},
      resizeHandler: null
    };
  },
  mounted() {
    this.loadData();
    this.resizeHandler = () => Object.values(this.charts).forEach(c => c && c.resize());
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    if (this.resizeHandler) window.removeEventListener("resize", this.resizeHandler);
    Object.values(this.charts).forEach(c => c && c.dispose());
  },
  methods: {
    formatMoney(num) {
      if (!num) return "0.00";
      return parseFloat(num).toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    initChart(refName) {
      if (this.charts[refName]) this.charts[refName].dispose();
      const dom = this.$refs[refName];
      if (!dom) return null;
      const chart = echarts.init(dom);
      this.charts[refName] = chart;
      return chart;
    },
    async loadData() {
      this.loading = true;
      await Promise.all([
        this.loadStats(),
        this.loadAttendanceTrend(),
        this.loadDriverRankChart(),
        this.loadDriverIncomeChart(),
        this.loadDriverTable()
      ]);
      this.loading = false;
      this.$nextTick(() => setTimeout(() => Object.values(this.charts).forEach(c => c && c.resize()), 200));
    },
    async loadStats() {
      try {
        const [realtime, period] = await Promise.all([
          this.$axios.get("/api/v1/manage/statistics"),
          this.$axios.get("/api/v1/manage/analysis/driver", { timeType: this.timeType, limit: 200 })
        ]);
        const d = realtime?.data || {};
        this.stats.totalDrivers = d.driverNum || 0;
        this.stats.onlineDrivers = d.driverOnlineNum || 0;
        this.stats.runningDrivers = d.driverRunningNum || 0;

        const driverList = period?.data || [];
        this.stats.periodOrders = driverList.reduce((s, r) => s + (r.orderCount || 0), 0);
        this.stats.periodRevenue = driverList.reduce((s, r) => s + parseFloat(r.totalRevenue || 0), 0).toFixed(2);
        const rates = driverList.filter(r => r.completionRate != null).map(r => Number(r.completionRate));
        this.stats.avgCompletionRate = rates.length ? (rates.reduce((a, b) => a + b, 0) / rates.length).toFixed(1) : 0;
      } catch (e) {
        console.error("加载统计数据失败", e);
      }
    },
    async loadAttendanceTrend() {
      try {
        const ttMap = { 0: '0', 7: '2', 30: '3', 180: '4', 365: '5' };
        const res = await this.$axios.get("/api/v1/manage/statistics/report", {
          timeType: ttMap[this.attendanceTimeType] || '0'
        });
        const list = res?.data?.statisticsReportVos || [];
        const xData = list.map(item => {
          let t = item.time || "";
          if (t.includes(" ")) t = t.split(" ")[0];
          if (t.length === 10) t = t.substring(5);
          return t;
        });
        const onlineData = list.map(item => item.driverOnlineNum || 0);
        const runningData = list.map(item => item.driverRunningNum || 0);
        const isEmpty = list.length === 0;
        const option = {
          tooltip: { trigger: "axis", backgroundColor: "rgba(50,50,50,0.9)", textStyle: { color: "#fff" } },
          legend: { data: ["在线司机", "运营司机"], bottom: 0, textStyle: { color: "#666" } },
          grid: { left: "3%", right: "4%", bottom: "15%", top: "10%", containLabel: true },
          graphic: isEmpty ? [{ type: "text", left: "center", top: "middle", style: { text: "暂无数据", fill: "#c0c4cc", fontSize: 14 } }] : [],
          xAxis: { type: "category", boundaryGap: false, data: xData, axisLine: { lineStyle: { color: "#ddd" } }, axisLabel: { color: "#666" } },
          yAxis: { type: "value", axisLine: { show: false }, splitLine: { lineStyle: { color: "#f0f0f0" } }, axisLabel: { color: "#666" } },
          series: [
            { name: "在线司机", type: "line", smooth: true, data: onlineData, itemStyle: { color: "#409EFF" }, areaStyle: { color: new echarts.graphic.LinearGradient(0,0,0,1,[{offset:0,color:"rgba(64,158,255,0.3)"},{offset:1,color:"rgba(64,158,255,0.05)"}]) } },
            { name: "运营司机", type: "line", smooth: true, data: runningData, itemStyle: { color: "#67C23A" }, areaStyle: { color: new echarts.graphic.LinearGradient(0,0,0,1,[{offset:0,color:"rgba(103,194,58,0.2)"},{offset:1,color:"rgba(103,194,58,0.02)"}]) } }
          ]
        };
        const c = this.initChart('attendanceTrendChart'); c && c.setOption(option);
        // 渲染状态分布饼图（依赖 stats）
        this.$nextTick(() => this.renderDriverStatus());
      } catch (e) {
        console.error("加载出勤趋势失败", e);
      }
    },
    renderDriverStatus() {
      const option = {
        tooltip: { trigger: "item", formatter: "{b}: {c}人 ({d}%)" },
        legend: { orient: "vertical", right: "5%", top: "center", textStyle: { color: "#666" } },
        series: [{
          type: "pie", radius: ["40%", "65%"], center: ["38%", "50%"],
          label: { show: false },
          emphasis: { label: { show: true, fontSize: 13, fontWeight: "bold" } },
          data: [
            { value: this.stats.runningDrivers, name: "运营中", itemStyle: { color: "#67C23A" } },
            { value: Math.max(0, this.stats.onlineDrivers - this.stats.runningDrivers), name: "在线空闲", itemStyle: { color: "#409EFF" } },
            { value: Math.max(0, this.stats.totalDrivers - this.stats.onlineDrivers), name: "离线", itemStyle: { color: "#909399" } }
          ]
        }]
      };
      const c = this.initChart('driverStatusChart'); c && c.setOption(option);
    },
    async loadDriverRankChart() {
      try {
        const res = await this.$axios.get("/api/v1/manage/analysis/driver", { timeType: this.rankTimeType, limit: 10 });
        const list = (res?.data || []).sort((a,b)=>(b.orderCount||0)-(a.orderCount||0)).slice(0, 10);
        const names = list.map(d => d.driverName || "").slice().reverse();
        const values = list.map(d => d.orderCount || 0).slice().reverse();
        const isEmpty = list.length === 0;
        const option = {
          tooltip: { trigger: "axis", axisPointer: { type: "shadow" }, formatter: p => `${p[0].name}<br/>工单数: <b>${p[0].value}</b>` },
          grid: { left: "3%", right: "12%", bottom: "3%", top: "3%", containLabel: true },
          graphic: isEmpty ? [{ type: "text", left: "center", top: "middle", style: { text: "暂无数据", fill: "#c0c4cc", fontSize: 14 } }] : [],
          xAxis: { type: "value", axisLine: { show: false }, splitLine: { lineStyle: { color: "#f0f0f0" } }, axisLabel: { color: "#666" } },
          yAxis: { type: "category", data: names, axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: "#606266", fontSize: 12 } },
          series: [{ type: "bar", data: values, barWidth: 14,
            itemStyle: { color: new echarts.graphic.LinearGradient(0,0,1,0,[{offset:0,color:"#409EFF"},{offset:1,color:"#66B1FF"}]), borderRadius: [0,6,6,0] },
            label: { show: true, position: "right", color: "#666", fontSize: 11 }
          }]
        };
        const c = this.initChart('driverRankChart'); c && c.setOption(option);
      } catch (e) { console.error("加载司机排行失败", e); }
    },
    async loadDriverIncomeChart() {
      try {
        const res = await this.$axios.get("/api/v1/manage/analysis/driver", { timeType: this.incomeRankTimeType, limit: 10 });
        const list = (res?.data || []).sort((a,b)=>parseFloat(b.totalRevenue||0)-parseFloat(a.totalRevenue||0)).slice(0, 10);
        const names = list.map(d => d.driverName || "").slice().reverse();
        const values = list.map(d => parseFloat(d.totalRevenue || 0)).slice().reverse();
        const isEmpty = list.length === 0;
        const option = {
          tooltip: { trigger: "axis", axisPointer: { type: "shadow" }, formatter: p => `${p[0].name}<br/>收入: ¥<b>${p[0].value.toFixed(2)}</b>` },
          grid: { left: "3%", right: "12%", bottom: "3%", top: "3%", containLabel: true },
          graphic: isEmpty ? [{ type: "text", left: "center", top: "middle", style: { text: "暂无数据", fill: "#c0c4cc", fontSize: 14 } }] : [],
          xAxis: { type: "value", axisLine: { show: false }, splitLine: { lineStyle: { color: "#f0f0f0" } }, axisLabel: { color: "#666", formatter: v => v >= 1000 ? (v/1000).toFixed(1)+"k" : v } },
          yAxis: { type: "category", data: names, axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: "#606266", fontSize: 12 } },
          series: [{ type: "bar", data: values, barWidth: 14,
            itemStyle: { color: new echarts.graphic.LinearGradient(0,0,1,0,[{offset:0,color:"#67C23A"},{offset:1,color:"#85CE61"}]), borderRadius: [0,6,6,0] },
            label: { show: true, position: "right", color: "#666", fontSize: 11, formatter: p => "¥"+(p.value>=1000?(p.value/1000).toFixed(1)+"k":p.value.toFixed(0)) }
          }]
        };
        const c = this.initChart('driverIncomeChart'); c && c.setOption(option);
      } catch (e) { console.error("加载司机收入排行失败", e); }
    },
    async loadDriverTable() {
      this.tableLoading = true;
      try {
        const res = await this.$axios.get("/api/v1/manage/analysis/driver", { timeType: this.tableTimeType });
        this.driverTableData = (res?.data || []).sort((a,b)=>(b.orderCount||0)-(a.orderCount||0));
      } catch (e) {
        console.error("加载司机表格失败", e);
        this.driverTableData = [];
      }
      this.tableLoading = false;
    }
  }
};
</script>

<style lang="less" scoped>
.driver-analysis-page {
  padding: 20px;
  background: #f5f7fa;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;

  .filter-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 16px 20px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    i { margin-right: 8px; color: #409EFF; }
  }

  .overview-cards {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 14px;
    margin-bottom: 24px;

    .ov-card {
      background: #fff;
      border-radius: 10px;
      padding: 16px;
      display: flex;
      align-items: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      transition: all 0.2s ease;
      &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.1); }

      .ov-card-icon {
        width: 40px; height: 40px; border-radius: 10px;
        display: flex; align-items: center; justify-content: center;
        margin-right: 12px; flex-shrink: 0;
        i { color: #fff; font-size: 18px; }
      }
      .ov-card-info {
        min-width: 0;
        .ov-card-value { font-size: 20px; font-weight: 700; color: #303133; }
        .ov-card-label { font-size: 12px; color: #909399; margin-top: 2px; }
      }
    }
  }

  .chart-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    overflow: hidden;
    min-width: 0;

    .chart-card-header {
      padding: 14px 20px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 14px; font-weight: 600; color: #303133;
      display: flex; align-items: center; justify-content: space-between;
      i { margin-right: 6px; color: #409EFF; }
    }
    .chart-body { width: 100%; height: 320px; padding: 10px; box-sizing: border-box; }
  }

  .charts-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px; }
  .charts-grid-half { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; margin-bottom: 20px; }

  .table-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    overflow: hidden;
    .chart-card-header {
      padding: 14px 20px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 14px; font-weight: 600; color: #303133;
      display: flex; align-items: center; justify-content: space-between;
      i { margin-right: 6px; color: #409EFF; }
    }
  }

}
</style>
